/* eslint-disable @typescript-eslint/no-empty-function */
import * as React from 'react'
import { ListItemButton, ListItemText, useMediaQuery, Box } from '@mui/material'
import KeycloakService from 'services/KeycloakService'
import { theme } from 'theme'

interface Props {
  icon?: React.ReactElement
  primary: string
  open: boolean
  onClick?: (e: React.MouseEvent) => void
}

export default function DrawerButton(props: Props) {
  const { icon, primary, open, onClick = () => {} } = props
  const MOBILE_SCREEN = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <Box component="li" sx={{ width: '100%' }}>
      <ListItemButton
        onClick={onClick}
        sx={{
          minWidth: '56px',
          maxWidth: open ? '100%' : '56px',
          textAlign: 'center',
          height: '56px',
          mt:
            KeycloakService.isOnlyUser() && MOBILE_SCREEN
              ? '136px' //'282px'
              : KeycloakService.isOnlyUser() && !MOBILE_SCREEN
              ? '136px' //'332px'
              : KeycloakService.isAgent()
              ? '136px'
              : KeycloakService.isAdmin()
              ? '20px'
              : '196px',
          mb:
            KeycloakService.isOnlyUser() && MOBILE_SCREEN
              ? '51px'
              : KeycloakService.isOnlyUser() && !MOBILE_SCREEN
              ? '60px'
              : '50px',
          ml: open ? 'initial' : '12px',
          borderRadius: '12px',
          boxShadow: 26,
          '&:hover': {
            boxShadow:
              '3px 3px 8px rgba(9, 9, 9, 0.3), 4px 4px 6px 0px #FFFFFF66 inset',
            '&:active': {
              borderColor: 'transparent',
              boxShadow: 'inset 8px 6px 4px rgba(0,0,0, 0.1)',
              bgcolor: 'primary.main',
            },
          },
        }}
      >
        <ListItemText
          primary={
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  mr: open ? '20px' : 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {icon}
              </Box>
              {open ? (
                <Box
                  sx={{
                    fontSize: { xs: '16px', sm: '18px' },
                  }}
                >
                  {primary}
                </Box>
              ) : null}
            </Box>
          }
        />
      </ListItemButton>
    </Box>
  )
}
